import React from "react";

const Footer = () => {
    return (
        <footer className="footer mt-4" style={{
            position: 'fixed',
        }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">
                        <script>document.write(new Date().getFullYear())</script> © POS.
                    </div>
                    <div className="col-sm-6">
                        <div className="text-sm-end d-none d-sm-block">
                            Design & Develop by POS
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;